import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import '../../assets/css/sub/style.css'
import '../../assets/css/sub/reset.css'

const SimpleHeader = (props) => {
    return (
        <React.Fragment>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {  }
}
const actionCreators = {

}

export default connect(mapStateToProps, actionCreators)(SimpleHeader)
